import { QueryCache, QueryClient, QueryClientProvider } from 'react-query';
import { ReactQueryDevtools } from 'react-query/devtools';
import { RouterProvider } from 'react-router-dom';

import { ThemeProvider } from '@mui/material';
import { LocalizationProvider } from '@mui/x-date-pickers';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';

import EditorContextProvider from '@frontend/features/cases/hooks/useEditor';
import { TwilioContextProvider } from '@frontend/features/communications/TwilioContextProvider/provider';
import { AuthContextProvider } from '../../../auth/components/AuthContext';
import { router } from '../../../../router/router';
import { theme } from '../../../../theme';
import { SnackBarContextProvider } from '../SnackBarContext';
import { SidebarContextProvider } from '../../../dashboard/contexts/SidebarContext';
import { SiteConfigContextProvider } from '../SiteConfigContext';
import { CartContextProvider } from '@frontend/features/cart/components/CartContext';
import { NotificationProvider } from '../../../../contexts/NotificationContext';
import { PwaUpdatePrompt } from '../PwaUpdatePrompt';

const queryClient = new QueryClient({
  queryCache: new QueryCache({
    onError: (error, query) => {
      const errorHandler = query?.meta?.errorHandler;
      if (errorHandler && typeof errorHandler === 'function') {
        errorHandler(error);
      }
    },
  }),
});

export const Providers = () => (
  <ThemeProvider theme={theme}>
    <SnackBarContextProvider>
      <>
        <PwaUpdatePrompt />
        <QueryClientProvider client={queryClient}>
          <ReactQueryDevtools initialIsOpen={false} />
          <SiteConfigContextProvider>
            <AuthContextProvider>
              <NotificationProvider>
                <SidebarContextProvider>
                  <EditorContextProvider>
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <TwilioContextProvider>
                        <CartContextProvider>
                          <RouterProvider router={router} />
                        </CartContextProvider>
                      </TwilioContextProvider>
                    </LocalizationProvider>
                  </EditorContextProvider>
                </SidebarContextProvider>
              </NotificationProvider>
            </AuthContextProvider>
          </SiteConfigContextProvider>
        </QueryClientProvider>
      </>
    </SnackBarContextProvider>
  </ThemeProvider>
);
